// Lot 562 — « Inscription Express » : brouillon d'inscription conservé pendant la session (sessionStorage) pour
// survivre aux allers-retours (CGU, FAQ, « Se connecter », rechargement). Jamais le mot de passe ni la case CGU.
export const REGISTER_DRAFT_KEY = "yalola.regDraft";
export const REGISTER_DRAFT_TTL_MS = 24 * 3600 * 1000;

const store = () => { try { return window.sessionStorage; } catch { return null; } };

export const draftHasContent = (d) =>
  !!d && !!((d.regData?.first_name || "").trim() || (d.regData?.last_name || "").trim() || (d.regIdentifier || "").trim()
    || (d.regData?.email || "").trim() || (d.regPhone?.national || "").trim());

export const loadRegisterDraft = (now = Date.now()) => {
  const s = store();
  if (!s) return null;
  try {
    const d = JSON.parse(s.getItem(REGISTER_DRAFT_KEY) || "null");
    if (!d || typeof d !== "object") return null;
    if (!d.savedAt || now - d.savedAt > REGISTER_DRAFT_TTL_MS || !draftHasContent(d)) { s.removeItem(REGISTER_DRAFT_KEY); return null; }
    return d;
  } catch { return null; }
};

export const saveRegisterDraft = (draft, now = Date.now()) => {
  const s = store();
  if (!s) return;
  const { password, ...regData } = draft.regData || {};
  const clean = { ...draft, regData, savedAt: now };
  try {
    if (draftHasContent(clean)) s.setItem(REGISTER_DRAFT_KEY, JSON.stringify(clean));
    else s.removeItem(REGISTER_DRAFT_KEY);
  } catch { /* quota / mode privé */ }
};

export const clearRegisterDraft = () => { try { store()?.removeItem(REGISTER_DRAFT_KEY); } catch { /* noop */ } };
